export function getCreatedByLabel(createdByAccount: string): string {
  return createdByAccount.length > 0 ? createdByAccount : '—';
}
